(() => {
  const setPlayingState = (wrapper, isPlaying) => {
    wrapper.classList.toggle('is-playing', isPlaying);
    const button = wrapper.querySelector('[data-showcase-video-toggle]');
    if (button) {
      button.setAttribute('aria-label', isPlaying ? 'Pauză video' : 'Redă video');
      button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    }
  };

  const prepareVideo = (video) => {
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.playsInline = true;
    video.controls = false;
  };

  const pauseVideo = (wrapper, video) => {
    video.pause();
    setPlayingState(wrapper, false);
  };

  const pauseOtherVideos = (currentWrapper) => {
    document.querySelectorAll('[data-showcase-video]').forEach((wrapper) => {
      if (wrapper === currentWrapper) return;
      const video = wrapper.querySelector('video');
      if (video && !video.paused) pauseVideo(wrapper, video);
    });
  };

  const playVideo = async (wrapper, video) => {
    pauseOtherVideos(wrapper);
    prepareVideo(video);
    video.muted = false;

    try {
      await video.play();
      setPlayingState(wrapper, true);
    } catch (error) {
      // If the browser blocks custom playback, expose native controls rather than navigating away.
      video.controls = true;
    }
  };

  const toggleVideo = (wrapper, video) => {
    if (video.paused || video.ended) {
      if (video.ended) {
        try { video.currentTime = 0; } catch (error) {}
      }
      playVideo(wrapper, video);
    } else {
      pauseVideo(wrapper, video);
    }
  };

  document.querySelectorAll('[data-showcase-video] video').forEach(prepareVideo);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-showcase-video-toggle]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const wrapper = button.closest('[data-showcase-video]');
      const video = wrapper?.querySelector('video');
      if (!wrapper || !video) return;

      toggleVideo(wrapper, video);
      return;
    }

    const video = event.target.closest('[data-showcase-video] video');
    if (video) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const wrapper = video.closest('[data-showcase-video]');
      if (!wrapper) return;
      toggleVideo(wrapper, video);
    }
  }, true);

  document.addEventListener('ended', (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement)) return;
    const wrapper = video.closest('[data-showcase-video]');
    if (!wrapper) return;

    try { video.currentTime = 0; } catch (error) {}
    setPlayingState(wrapper, false);
  }, true);

  document.addEventListener('pause', (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement)) return;
    const wrapper = video.closest('[data-showcase-video]');
    if (!wrapper || video.ended) return;
    setPlayingState(wrapper, false);
  }, true);

  document.addEventListener('play', (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement)) return;
    const wrapper = video.closest('[data-showcase-video]');
    if (!wrapper) return;
    pauseOtherVideos(wrapper);
    setPlayingState(wrapper, true);
  }, true);


  const closeMobilePicker = (picker, returnFocus = false) => {
    if (!picker) return;
    const trigger = picker.querySelector('[data-mobile-tab-trigger]');
    const menu = picker.querySelector('[data-mobile-tab-menu]');
    picker.dataset.open = 'false';
    trigger?.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
    if (returnFocus) trigger?.focus();
  };

  const openMobilePicker = (picker) => {
    if (!picker) return;
    document.querySelectorAll('[data-mobile-tab-picker][data-open="true"]').forEach((other) => {
      if (other !== picker) closeMobilePicker(other);
    });
    const trigger = picker.querySelector('[data-mobile-tab-trigger]');
    const menu = picker.querySelector('[data-mobile-tab-menu]');
    picker.dataset.open = 'true';
    trigger?.setAttribute('aria-expanded', 'true');
    if (menu) menu.hidden = false;
  };

  const syncMobilePicker = (picker) => {
    const select = picker?.querySelector('[data-mobile-tab-native]');
    if (!select) return;
    const label = picker.querySelector('[data-mobile-tab-label]');
    const selectedText = select.options[select.selectedIndex]?.textContent?.trim() || '';
    if (label) label.textContent = selectedText;
    picker.querySelectorAll('[data-mobile-tab-option]').forEach((option) => {
      const active = option.dataset.value === String(select.value);
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  };

  const initMobileTabPickers = (root = document) => {
    root.querySelectorAll('[data-mobile-tab-picker]').forEach((picker) => {
      if (picker.dataset.pickerReady === 'true') return;
      picker.dataset.pickerReady = 'true';
      picker.dataset.open = 'false';
      syncMobilePicker(picker);

      const select = picker.querySelector('[data-mobile-tab-native]');
      select?.addEventListener('change', () => syncMobilePicker(picker));
    });
  };

  initMobileTabPickers();
  document.addEventListener('shopify:section:load', (event) => initMobileTabPickers(event.target));

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mobile-tab-trigger]');
    if (trigger) {
      event.preventDefault();
      const picker = trigger.closest('[data-mobile-tab-picker]');
      if (!picker) return;
      picker.dataset.open === 'true' ? closeMobilePicker(picker) : openMobilePicker(picker);
      return;
    }

    const option = event.target.closest('[data-mobile-tab-option]');
    if (option) {
      event.preventDefault();
      const picker = option.closest('[data-mobile-tab-picker]');
      const select = picker?.querySelector('[data-mobile-tab-native]');
      if (!picker || !select) return;
      select.value = option.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncMobilePicker(picker);
      closeMobilePicker(picker, true);
      return;
    }

    document.querySelectorAll('[data-mobile-tab-picker][data-open="true"]').forEach((picker) => {
      if (!picker.contains(event.target)) closeMobilePicker(picker);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const picker = document.querySelector('[data-mobile-tab-picker][data-open="true"]');
    if (picker) closeMobilePicker(picker, true);
  });

})();
